module.exports = "/_next/static/images/270943a2848ca707de18e4b709b1f860-image-right-xs.jpg";